import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Box, ListItemButton, ListItemIcon, ListItemText, Collapse } from '@mui/material';
import PaymentsOutlinedIcon from '@mui/icons-material/PaymentsOutlined';
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import PermMediaOutlinedIcon from '@mui/icons-material/PermMediaOutlined';
import ComputerOutlinedIcon from '@mui/icons-material/ComputerOutlined';
import ModeCommentOutlinedIcon from '@mui/icons-material/ModeCommentOutlined';
import routes from '../../../Utils/routes';
import { useStyles } from '../styles';
import { ReactComponent as InfoHub } from '../../../Assets/icons/InfoHub.svg';
import { ReactComponent as Home } from '../../../Assets/icons/Home copy.svg';
import MenuBookOutlinedIcon from '@mui/icons-material/MenuBookOutlined';
import { ReactComponent as Logout1 } from '../../../Assets/icons/LogOut1.svg';
import { ReactComponent as Myprofile } from '../../../Assets/MobileIcon/Myprofile.svg';
import { ReactComponent as Survey } from '../../../Assets/MobileIcon/Survey.svg';
import { ReactComponent as Jobs } from '../../../Assets/MobileIcon/Jobs.svg';
import { ReactComponent as Mentorship } from '../../../Assets/MobileIcon/Mentorship.svg';
import { ReactComponent as Myfeed } from '../../../Assets/MobileIcon/Myfeed.svg';
import { ReactComponent as Servicesupport } from '../../../Assets/MobileIcon/Servicesupport.svg';
import { ReactComponent as Events } from '../../../Assets/MobileIcon/Events.svg';
import { ReactComponent as Network } from '../../../Assets/MobileIcon/Network.svg';
interface SideNavProps {
  handleListClick: (link: string, index: number) => void;
  name?: string;
  handleClose?: any;
}

const MobileNavTabs: React.FunctionComponent<SideNavProps> = ({ handleListClick, name, handleClose }) => {
  const classes = useStyles();
  const { pathname } = useLocation();
  const getFirstPath = pathname.split('/').filter((items: string) => {
    return items && items !== '';
  });

  const isInInfoHubSection = ['photos', 'resources', 'business%20directory'].includes(getFirstPath[0]);
  const [openInfoHub, setOpenInfoHub] = useState(isInInfoHubSection);

  const navigationItems = [
    {
      icon: <Home style={{ color: "#fff" }} />,
      label: 'Home',
      link: routes.home,
      name: 'home',
    },
    {
      icon: <Myprofile />,
      label: 'My Profile',
      link: routes.myProfile,
      name: 'myProfile',
    },
    {
      icon: <Myfeed style={{ color: "#fff" }} />,
      label: 'Feed',
      link: routes.myFeed,
      name: 'my%20Feed',
    },
    {
      icon: <Events style={{ color: "#fff" }} />,
      label: 'Events',
      link: routes.events,
      name: 'events',
    },
    {
      icon: <Jobs style={{ color: "#fff" }} />,
      label: 'Jobs',
      link: routes.jobs,
      name: 'jobs',
    },
    {
      icon: <Mentorship style={{ color: "#fff" }} />,
      label: 'Mentorship',
      link: routes.mentorship,
      name: 'mentorship',
    },
    {
      icon: <PaymentsOutlinedIcon style={{ color: "#fff" }} />,
      label: 'Fundraise',
      link: routes.fundraise,
      name: 'fundraise',
    },
    {
      icon: <Network style={{ color: "#fff" }} />,
      label: 'Network',
      link: routes.network,
      name: 'network',
    },
    {
      icon: <GroupsOutlinedIcon style={{ color: "#fff" }} />,
      label: 'Groups',
      link: routes.groups,
      name: 'groups',
    },
    {
      icon: <InfoHub style={{ color: "#fff" }} />,
      label: 'Info Hub',
      name: 'infohub',
      isDropdown: true,
      children: [
        {
          label: 'Photos',
          link: routes.photos,
          name: 'photos',
          icon: <PermMediaOutlinedIcon style={{ color: "#fff" }} />,
        },
        {
          label: 'Business Directory',
          link: routes.businessdirectory,
          name: 'business%20directory',
          icon: <ComputerOutlinedIcon style={{ color: "#fff" }} />,
        },
        {
          label: 'Resources',
          link: routes.resources,
          name: 'resources',
          icon: <MenuBookOutlinedIcon style={{ color: "#fff" }} />,
        },
      ],
    },
    {
      icon: <Survey style={{ color: "#fff" }} />,
      label: 'Survey',
      link: routes.survey,
      name: 'survey',
    },
    {
      icon: <Servicesupport style={{ color: "#fff" }} />,
      label: 'Service & Support',
      link: routes.service,
      name: 'service',
    },
    {
      icon: <SettingsOutlinedIcon style={{ color: "#fff" }} />,
      label: 'Settings',
      link: routes.settings,
      name: 'settings',
    },
    {
      icon: <ModeCommentOutlinedIcon style={{ color: "#fff" }} />,
      label: 'Chat',
      link: routes.chats,
      name: 'chats',
    },
  ];

  const handleNavigation = (link: string, index: number) => {
    // console.log('Mobile navigation to:', link);

    if (handleClose) {
      handleClose();
    }

    setTimeout(() => {
      handleListClick(link, index);
    }, 50);
  };

  const isInfoHubActive = navigationItems
    .find((item: any) => item.isDropdown)
    ?.children?.some((subItem: any) => getFirstPath[0] === subItem.name);

  return (
    <>
      <Box sx={{ flex: 1, overflowY: 'auto', height: 'calc(95vh - 230px)' }}>
        {navigationItems.map((item, index) => {
          if (item.isDropdown) {
            return (
              <div key={item.label}>
                <ListItemButton
                  onClick={() => setOpenInfoHub(!openInfoHub)}
                  sx={{
                    py: 1.5,
                    pl: 2,
                    pr: 1,
                    borderRadius: '4px',
                    '&:hover': {
                      backgroundColor: '#f5f8ff',
                    },
                    ...(isInfoHubActive && {
                      backgroundColor: '#f5f8ff',
                    }),
                  }}
                >
                  <ListItemIcon sx={{ minWidth: '36px', color: '#5981FF' }}>
                    {item.icon}
                  </ListItemIcon>
                  <ListItemText
                    primary={item.label}
                    sx={{
                      m: 0,
                      '& .MuiTypography-root': {
                        fontSize: '16px',
                        fontWeight: isInfoHubActive ? 500 : 400,
                        color: isInfoHubActive ? '#373A45' : '#373A45',
                      },
                    }}
                  />
                  {openInfoHub ? <ExpandLess /> : <ExpandMore />}
                </ListItemButton>

                <Collapse in={openInfoHub} timeout="auto" unmountOnExit>
                  {item.children.map((subItem: any) => {
                    const isSubItemActive = getFirstPath[0] === subItem.name;
                    return (
                      <ListItemButton
                        key={subItem.label}
                        onClick={() => handleNavigation(subItem.link, index)}
                        sx={{
                          py: 1.5,
                          pl: 4,
                          pr: 1,
                          borderRadius: '4px',
                          '&:hover': {
                            backgroundColor: '#f5f8ff',
                          },
                          ...(isSubItemActive && {
                            backgroundColor: '#f5f8ff',
                          }),
                        }}
                      >
                        <ListItemIcon sx={{ minWidth: '36px', color: '#5981FF' }}>
                          {subItem.icon}
                        </ListItemIcon>
                        <ListItemText
                          primary={subItem.label}
                          sx={{
                            m: 0,
                            '& .MuiTypography-root': {
                              fontSize: '16px',
                              fontWeight: isSubItemActive ? 500 : 400,
                              color: isSubItemActive ? '#373A45' : '#373A45',
                            },
                          }}
                        />
                      </ListItemButton>
                    );
                  })}
                </Collapse>
              </div>
            );
          } else {
            return (
              <ListItemButton
                key={index}
                onClick={() => handleNavigation(item.link || '', index)}
                sx={{
                  py: 1.5,
                  pl: 2,
                  pr: 1,
                  borderRadius: '4px',
                  '&:hover': {
                    backgroundColor: '#f5f8ff',
                  },
                  ...(getFirstPath[0] === item.name && {
                    backgroundColor: '#f5f8ff',
                  }),
                }}
              >
                <ListItemIcon sx={{ minWidth: '36px', color: '#5981FF' }}>
                  {item.icon}
                </ListItemIcon>
                <ListItemText
                  primary={item.label}
                  sx={{
                    m: 0,
                    '& .MuiTypography-root': {
                      fontSize: '16px',
                      fontWeight: getFirstPath[0] === item.name ? 500 : 400,
                      color: getFirstPath[0] === item.name ? '#373A45' : '#373A45',
                    },
                  }}
                />
              </ListItemButton>
            );
          }
        })}
      </Box>
      <Box sx={{
        borderTop: '1px solid #EAEFFF',
        mt: 2,
        pt: 2,
        px: 1,
        position: 'fixed',
        bottom: 0,
        width: 'calc(100% - 32px)',
        backgroundColor: 'white'
      }}>
        <ListItemButton
          onClick={() => handleNavigation(routes.landingpage, navigationItems.length + 1)}
          sx={{
            py: 1.5,
            pl: 2,
            pr: 1,
            borderRadius: '4px',
            '&:hover': {
              backgroundColor: '#f5f8ff',
            },
          }}
        >
          <ListItemIcon sx={{ minWidth: '40px', color: '#2C60AA' }}>
            <Logout1 style={{ width: "26px", height: "26px" }} />
          </ListItemIcon>
          <ListItemText
            primary="Logout"
            sx={{
              m: 0,
              '& .MuiTypography-root': {
                fontSize: '16px',
                color: '#373A45',
              },
            }}
          />
        </ListItemButton>
      </Box>
    </>
  );
};

export default MobileNavTabs;
